import { Button, Modal, Row } from "antd";
import PageLayout from "../../components/layout/PageLayout/PageLayout";
import TableConstatGravities from "../../components/tables/TableConstatGravities/TableConstatGravities";
import FormConstatGravity, {
  transformConstatGravityToFormValues,
} from "../../components/forms/FormConstatGravity";
import { useLazyFetchPaginatedConstatGravitiesQuery } from "../../features/api/apiSlice";
import { useCrudConstatGravity } from "../../features/api/crud/hooks/useCrudConstatGravity";
import { useModal } from "../PageUsers/useModal";
import { modalProps } from "../../features/modals/modalProps";
import styles from "./PageConstatGravities.module.scss";

const PageConstatGravities: React.FC = () => {
  const [fetchConstatGravities, { data, isFetching }] =
    useLazyFetchPaginatedConstatGravitiesQuery();

  const { isModalOpen, modalItemId, onShowModal, onHideModal, onModifyShowModal } =
    useModal();

  const {
    createConstatGravity,
    isCreating,
    updateConstatGravity,
    isUpdating,
    onDelete,
    isDeleting,
  } = useCrudConstatGravity(modalItemId, () => fetchConstatGravities(), onHideModal);

  const formMode = modalItemId ? "update" : "create";
  const modalConstatGravity = data?.results?.find((a) => a.id === modalItemId);

  return (
    <PageLayout pageContainerClassName={styles.root}>
      <div className={styles.top}>
        <h1>Les gravitÃ©s de constat</h1>
        <Button type="primary" onClick={onShowModal}>
          CrÃ©er une gravitÃ© de constat
        </Button>
      </div>
      <Row>
        <TableConstatGravities
          data={data}
          fetchData={fetchConstatGravities}
          isLoading={isFetching || isDeleting}
          onModify={onModifyShowModal}
          onDelete={onDelete}
        />
      </Row>
      <Modal
        {...modalProps}
        title={
          formMode === "create"
            ? "CrÃ©er une gravitÃ© de constat"
            : "Modifier une gravitÃ© de constat"
        }
        open={isModalOpen}
        onCancel={onHideModal}
        footer={
          <>
            <Button onClick={onHideModal} disabled={isCreating || isUpdating}>
              Annuler
            </Button>
            <Button
              type="primary"
              htmlType="submit"
              form="form-constat-gravity"
              loading={isCreating || isUpdating}
            >
              {formMode === "create" ? "Ajouter" : "Mettre Ã  jour"}
            </Button>
          </>
        }
      >
        <br />
        <FormConstatGravity
          key={modalConstatGravity?.id ?? "new"}
          onSubmit={formMode === "create" ? createConstatGravity : updateConstatGravity}
          defaultValues={transformConstatGravityToFormValues(modalConstatGravity)}
        />
      </Modal>
    </PageLayout>
  );
};

export default PageConstatGravities;
